<section
  class="hd-gate-info-full"
  [class.hd-gate-info-full--floating]="isFloating"
  [class.hd-gate-info-full--variant-b]="sectionVariant() === 'b'"
  [class.hd-gate-info-full--variant-c]="sectionVariant() === 'c'"
  [class.hd-gate-info-full--transit-only]="isTransitOnlyGate()"
  [class.hd-gate-info-full--cycle-transit]="isCycleTransitStyle()"
  [class.hd-gate-info-full--composite-base]="isCompositeBaseStyle()"
  [attr.data-gate]="gateInfo().gate"
>
  <header class="hd-gate-info-full__header">
    <div class="hd-gate-info-full__heading">
      <div class="hd-gate-info-full__glyph-block">
        <span class="hd-gate-info-full__gate-number">{{ gateInfo().gate }}</span>
        <span class="hd-gate-info-full__hexagram">{{ gateInfo().metadata.ichingChar }}</span>
      </div>
      <div class="hd-gate-info-full__heading-text">
        <h3 class="hd-gate-info-full__title">{{ gateInfo().translations.keynote1 }}</h3>
        @if (gateInfo().translations.keynote2) {
          <p class="hd-gate-info-full__keynote2">{{ gateInfo().translations.keynote2 }}</p>
        }
      </div>

      <div class="hd-gate-info-full__center">
        <span class="hd-gate-info-full__center-badge">
          <span class="hd-gate-info-full__center-icon" [innerHTML]="centerBadge().iconHtml" aria-hidden="true"></span>
          <span class="hd-gate-info-full__center-name">{{ centerBadge().name }}</span>
          @if (lineCompanionVisible()) {
            <!-- Line Companion (community-content): opent de boektekst van deze poort. -->
            <button
              type="button"
              class="hd-gate-info-full__lc-button"
              [title]="lineCompanionLabel()"
              [attr.aria-label]="lineCompanionLabel()"
              (click)="openLineCompanion($event)"
            >
              <i class="fa-regular fa-book-open-lines" aria-hidden="true"></i>
            </button>
          }
          @if (classicIChingVisible()) {
            <!-- Classic I Ching: opent de klassieke tekst van hexagram = poort. -->
            <button
              type="button"
              class="hd-gate-info-full__lc-button hd-gate-info-full__iching-button"
              [title]="classicIChingLabel()"
              [attr.aria-label]="classicIChingLabel()"
              (click)="openClassicIChing($event)"
            >
              <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
            </button>
          }
        </span>
        <div class="hd-gate-info-full__graph-row">
          @if (chartSearchAvailable()) {
            <!-- Charts uit de bibliotheek die deze poort activeren (klapt een lijst
                 onder de kop uit; volgt de scope-setting zoals de Basis-zoektochten). -->
            <button
              type="button"
              hdChartMatchToggle
              class="hd-gate-info-full__chart-search-button"
              [open]="chartSearchOpen()"
              [tooltip]="chartSearchLabels().tooltip"
              data-test-id="gate-info-chart-search-toggle"
              (click)="toggleChartSearch()"
            ></button>
          }
          <!-- Lock-/key-rol van de poort (Locks & Keys); klikbaar enkel op de chart-pagina. -->
          <hd-gate-locks-keys-icon [gate]="gateInfo().gate" />
          <button
            type="button"
            class="hd-gate-info-full__graph-button"
            [title]="graphButtonLabels().tooltip"
            [attr.aria-label]="graphButtonLabels().aria"
            (click)="openGateGraph($event)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <circle cx="12" cy="12" r="4.2"></circle>
              <circle cx="12" cy="3" r="1.9"></circle>
              <circle cx="19.8" cy="7.5" r="1.9"></circle>
              <circle cx="19.8" cy="16.5" r="1.9"></circle>
              <circle cx="12" cy="21" r="1.9"></circle>
              <circle cx="4.2" cy="16.5" r="1.9"></circle>
              <circle cx="4.2" cy="7.5" r="1.9"></circle>
            </svg>
          </button>
        </div>
        @if (headerIconRows().length > 0) {
          <!-- Poort-attribuut-iconen (angst, voice, liefde, geheugen, …) op
               poortniveau; iconen met een eigen paneel zijn klikbaar. -->
          <div class="hd-gate-info-full__gate-icons">
            @for (row of headerIconRows(); track $index) {
              <div class="hd-gate-info-full__gate-icon-row">
                @for (icon of row; track icon.key) {
                  <hd-gate-attribute-icon [gate]="gateInfo().gate" [iconKey]="icon.key" [label]="icon.label" />
                }
              </div>
            }
          </div>
        }
      </div>
    </div>

    @if (gateInfo().translations.shortIchingDescription) {
      <p class="hd-gate-info-full__short-iching">{{ gateInfo().translations.shortIchingDescription }}</p>
    }

    @if (footerCircuits().length > 0) {
      <!-- Circuit-vermelding: kleurblokje + naam + theme-keynote + theme-icoon,
           zelfde opbouw als de footer van de cheat-sheet-kaart (integratiepoorten
           krijgen een duo-kleurblokje). -->
      <div class="hd-gate-info-full__circuit-row">
        <span class="hd-gate-info-full__circuit-color" aria-hidden="true">
          @for (circuit of footerCircuits(); track circuit.key) {
            <span
              class="hd-gate-info-full__circuit-color-half"
              [style.background-color]="circuit.color"
            ></span>
          }
        </span>
        <span class="hd-gate-info-full__circuit-name">
          @for (circuit of footerCircuits(); track circuit.key; let last = $last) {
            <span>{{ circuit.name }}</span>
            @if (!last) {
              <span class="hd-gate-info-full__circuit-sep"> / </span>
            }
          }
        </span>
        @if (footerCircuits()[0].themeLabel; as themeLabel) {
          <span class="hd-gate-info-full__circuit-keynote">{{ themeLabel }}</span>
        }
        @if (footerCircuits()[0].themeIcon; as themeIcon) {
          <i
            class="fa-regular fa-{{ themeIcon }} hd-gate-info-full__circuit-theme-icon"
            [title]="footerCircuits()[0].themeLabel ?? ''"
            aria-hidden="true"
          ></i>
        }
      </div>
    }

    @if (melancholyTheme(); as melancholyTheme) {
      <!-- Melancholiethema (enkel poorten in individuele circuits), uitgelijnd
           onder de circuit-naam. -->
      <div class="hd-gate-info-full__melancholy-row">
        <span class="hd-gate-info-full__melancholy-label">{{ labels().melancholy }}:</span>
        <span class="hd-gate-info-full__melancholy-theme">{{ melancholyTheme }}</span>
      </div>
    }

    @if (emotionalWave(); as wave) {
      <!-- Emotionele golf (enkel de zeven Solar Plexus-poorten): golfje en
           golfnaam openen het golvenpaneel, daaronder de keynote van de poort. -->
      <hd-emotional-wave-row
        class="hd-gate-info-full__wave"
        data-test-id="gate-info-emotional-wave"
        [wave]="wave.wave"
        [keynoteKey]="wave.keynoteKey"
        [sourceLines]="wave.sourceLines"
        [definedChannelKeys]="emotionalWaveDefinedChannels()"
      />
    }
  </header>

  @if (chartSearchAvailable() && chartSearchOpen()) {
    <div class="hd-gate-info-full__chart-search" data-test-id="gate-info-chart-search">
      <div class="hd-gate-info-full__chart-search-title">{{ chartSearchLabels().title }}</div>
      <hd-chart-match-list [state]="chartSearchListState()" [labels]="chartSearchLabels()" [resetKey]="gate()"
                           (open)="openChartSearchMatch($event)">
        <!-- Sortering (bewaard in de gebruikersinstellingen) rechts in de kopregel,
             naast de scope: werkt op de treffers, zonder nieuwe zoektocht. -->
        <e-segmented-toggle
          matchListHead
          size="xs"
          [options]="chartSearchSortOptions()"
          [value]="chartSearchSort()"
          [groupLabel]="chartSearchLabels().sortLabel"
          testId="gate-info-chart-search-sort"
          (valueChange)="setChartSearchSort($event)"
        ></e-segmented-toggle>
        <!-- Welke planeet de poort bij de treffer activeert, in de zijdekleur; bij
             sortering op gewicht van zwaar naar licht, met de score erachter. -->
        <ng-template let-match>
          @for (activation of match.activations; track $index) {
            <hd-gate-activation-chip
              [gate]="activation.gate"
              [line]="activation.line"
              [side]="activation.side"
              [planetId]="activation.planetId"
            ></hd-gate-activation-chip>
          }
          @if (chartSearchSort() === 'weight') {
            <span
              class="hd-gate-info-full__chart-search-score"
              data-test-id="gate-info-chart-search-score"
              [title]="match.scoreTooltip"
            >{{ match.score }}</span>
          }
        </ng-template>
      </hd-chart-match-list>
    </div>
  }

  <ng-template #circuitTopbar>
    @if (footerCircuits().length > 0) {
      <div class="hd-gate-info-full__circuit-info">
        <span class="hd-gate-info-full__circuit-name">
          @for (circuit of footerCircuits(); track circuit.key; let last = $last) {
            <span>{{ circuit.name }}</span>
            @if (!last) {
              <span class="hd-gate-info-full__circuit-sep"> / </span>
            }
          }
        </span>
        @if (footerCircuits()[0].themeIcon; as themeIcon) {
          <i
            class="fa-regular fa-{{ themeIcon }} hd-gate-info-full__circuit-theme-icon"
            [title]="footerCircuits()[0].themeLabel ?? ''"
            [attr.aria-label]="footerCircuits()[0].themeLabel ?? null"
          ></i>
        }
      </div>
    }
  </ng-template>

  @if (activationViewModels().length > 0 || fallbackLines().length > 0) {
    <section class="hd-gate-info-full__section hd-gate-info-full__activation-lines">
      <h4>{{ sectionTitles().planetaryInfluences }}</h4>
      <ng-template #influenceSegments let-segments="segments">
        @for (seg of segments; track $index) {
          @if (seg.role === 'plain') {
            <span>{{ seg.text }}</span>
          } @else {
            <span class="marker-word"
                  [class.marker-personality]="seg.role === 'personality'"
                  [class.marker-design]="seg.role === 'design'">
              {{ seg.text }}<sup class="marker-superscript">{{ seg.markerSuperscript }}</sup>
            </span>
          }
        }
      </ng-template>
      <ul class="hd-gate-info-full__activation-list">
        <!-- Eerst de "geen activatie"-regel: een Chiron-regel (informatief) volgt erna. -->
        @for (line of fallbackLines(); track line) {
          <li class="hd-gate-info-full__activation-line">{{ line }}</li>
        }
        @for (vm of activationViewModels(); track vm.key) {
          <li class="hd-gate-info-full__activation-line"
              [class.hd-gate-info-full__activation-line--informative]="vm.informativeNote"
              [attr.data-test-id]="vm.informativeNote ? 'gate-info-chiron-line' : null">
            <div
              class="hd-gate-info-full__activation-headline"
              [class.is-design]="vm.side === 'design'"
              [class.is-personality]="vm.side === 'personality'"
              [class.is-transit]="vm.origin === 'transit'"
            >
              @if (vm.gate != null && vm.line != null) {
                <span class="hd-gate-info-full__activation-position">
                  <span class="hd-gate-info-full__activation-gate-num">{{ vm.gate }}</span><span class="hd-gate-info-full__activation-line-num">.{{ vm.line }}</span>
                </span>
              }
              @if (vm.glyph) {
                <span class="hd-gate-info-full__activation-glyph">{{ vm.glyph }}</span>
              }
              <span class="hd-gate-info-full__activation-headline-text">{{ vm.headline }}</span>
              @if (vm.subtitle) {
                <span class="hd-gate-info-full__activation-subtitle">: {{ vm.subtitle }}</span>
              }
              @if (vm.planetKey; as planetKey) {
                <button type="button" class="hd-gate-info-full__planet-info-button"
                        data-test-id="gate-info-planet-info"
                        [title]="planetInfoTooltip()"
                        [attr.aria-label]="planetInfoTooltip()"
                        (click)="openPlanetInfo(planetKey, $event)">
                  <i class="fas fa-circle-info" aria-hidden="true"></i>
                </button>
              }
            </div>
            @if (vm.detail; as detail) {
              <!-- Volledige activatie-keten (poort.lijn.kleur.toon.base) +
                   exacte zodiakpositie van de planeet uit de chart-data. -->
              <div class="hd-gate-info-full__activation-detail">
                @if (detail.chain) {
                  <span class="hd-gate-info-full__activation-chain">{{ detail.chain }}</span>
                }
                @if (detail.position; as pos) {
                  <span class="hd-gate-info-full__activation-coords">
                    <span>{{ pos.degreesText }}</span>
                    <span class="hd-gate-info-full__zodiac-glyph" aria-hidden="true">{{ pos.glyph }}</span>
                    <span class="hd-gate-info-full__zodiac-label">{{ pos.signLabel }}</span>
                    <span class="hd-gate-info-full__zodiac-absolute">({{ pos.absoluteText }})</span>
                  </span>
                }
              </div>
            }
            @if (vm.informativeNote; as note) {
              <div class="hd-gate-info-full__activation-informative-note">{{ note }}</div>
            }
            @if (vm.influenceSegments.length > 0) {
              <div class="hd-gate-info-full__activation-keynote">
                @if (vm.prefixText) {
                  <span class="hd-gate-info-full__activation-prefix">{{ vm.prefixText }}: </span>
                }
                <ng-container *ngTemplateOutlet="influenceSegments; context: { segments: vm.influenceSegments }"></ng-container>
              </div>
            }
            @for (variant of vm.influenceVariants; track variant.key) {
              <div class="hd-gate-info-full__activation-keynote hd-gate-info-full__activation-keynote--variant">
                <span class="hd-gate-info-full__activation-prefix">{{ variant.label }}: </span>
                <ng-container *ngTemplateOutlet="influenceSegments; context: { segments: variant.segments }"></ng-container>
              </div>
            }
          </li>
        }
      </ul>
    </section>
  }

  <section class="hd-gate-info-full__lines hd-gate-info-full__section">
    <div class="hd-gate-info-full__lines-header">
      <h4>{{ sectionTitles().lineCharacteristics }}</h4>
      @if (gateHasActivations()) {
        <e-segmented-toggle
          testId="gate-info-line-filter"
          [options]="lineFilterOptions()"
          [value]="lineFilter()"
          (valueChange)="setLineFilter($event)"
        ></e-segmented-toggle>
      }
    </div>

    @for (lineVm of displayedLineViewModels(); track lineVm.lineNumber) {
      <hd-gate-line class="hd-gate-info-full__line" [viewModel]="lineVm" />
    }
  </section>

  @if (gateInfo().translations.summary) {
    <section class="hd-gate-info-full__section">
      <h4>{{ sectionTitles().gateDescription }}</h4>
      <markdown class="hd-gate-info-full__markdown" [data]="gateInfo().translations.summary"></markdown>
    </section>
  }

  @if (gateInfo().translations.evolutionary) {
    <section class="hd-gate-info-full__section hd-gate-info-full__section--evolutionary">
      <h4>{{ sectionTitles().evolutionary }}</h4>
      <markdown class="hd-gate-info-full__markdown" [data]="gateInfo().translations.evolutionary"></markdown>
    </section>
  }

  @if (coordinates(); as coords) {
    <section class="hd-gate-info-full__section hd-gate-info-full__section--coordinates">
      <h4>{{ sectionTitles().coordinates }}</h4>
      <p>{{ coords.start }} — {{ coords.end }}</p>
    </section>
  }

  @if (gateInfo().translations.practicalImplications.length > 0) {
    <section class="hd-gate-info-full__section">
      <h4>{{ sectionTitles().practicalImplications }}</h4>
      <ul>
        @for (item of gateInfo().translations.practicalImplications; track $index) {
          <li><markdown class="hd-gate-info-full__markdown" [data]="item"></markdown></li>
        }
      </ul>
    </section>
  }

  @if (gateInfo().translations.reflectionQuestions.length > 0) {
    <section class="hd-gate-info-full__section">
      <h4>{{ sectionTitles().reflectionQuestions }}</h4>
      <ul>
        @for (item of gateInfo().translations.reflectionQuestions; track $index) {
          <li><markdown class="hd-gate-info-full__markdown" [data]="item"></markdown></li>
        }
      </ul>
    </section>
  }

  @if (categorySections().length > 0) {
    <section class="hd-gate-info-full__section">
      @for (entry of categorySections(); track entry.category) {
        <article class="hd-gate-info-full__category" [attr.data-category]="entry.category">
          <h5>{{ entry.category }}</h5>
          <markdown class="hd-gate-info-full__markdown" [data]="entry.description"></markdown>
        </article>
      }
    </section>
  }

  @if (activations().length > 0 && activationViewModels().length === 0 && fallbackLines().length === 0) {
    <section class="hd-gate-info-full__activations">
      <h4>{{ sectionTitles().activations }}</h4>
      @for (activation of activations(); track activation.id) {
        <span class="hd-gate-info-full__activation">{{ activation.planet }} ({{ activation.side }})</span>
      }
    </section>
  }
</section>
